<template>
  <div class="cathedra">

    <div class="head-links">
      <router-link class="back-links" to="/pediatrics">Головна</router-link>
      <span>/</span>
      <router-link class="now-page" to="/pediatrics/cathedra">Відкрита кафедра</router-link>
    </div>

    <div class="content-wrapper">

      <div class="top-block">
        <p class="h2-title">Відкрита кафедра</p>
        <div class="tabs">
          <button
              type="button"
              class="tabs-btn"
              :class="{active: activeTab === 1}"
              @click="setActiveTab(1)"
          >
            <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M26.296 19.7141L25.7873 20.2652L26.296 19.7141L30.8304 23.8997C30.9906 24.0475 31.25 23.934 31.25 23.716V1C31.25 0.861929 31.1381 0.75 31 0.75H1C0.861929 0.75 0.75 0.861929 0.75 1V19C0.75 19.1381 0.861929 19.25 1 19.25H25.109C25.549 19.25 25.9727 19.4157 26.296 19.7141Z"
                  stroke="#1E3B89" stroke-width="1.5"/>
              <path
                  d="M34.296 25.7141L33.7873 26.2652L34.296 25.7141L38.8304 29.8997C38.9906 30.0475 39.25 29.934 39.25 29.716V7C39.25 6.86193 39.1381 6.75 39 6.75H9C8.86193 6.75 8.75 6.86193 8.75 7V25C8.75 25.1381 8.86193 25.25 9 25.25H33.109C33.549 25.25 33.9727 25.4157 34.296 25.7141Z"
                  fill="white" stroke="#1E3B89" stroke-width="1.5"/>
              <path
                  d="M20.5 12C20.8506 11.2987 21.8672 10 24 10C25.5 10 27.3113 11.1215 26.9607 13.5759C26.6101 16.0303 23.4544 16.0303 23.4544 16.7316C23.4544 17.2926 23.4544 18.6016 23.4544 19.186"
                  stroke="#1E3B89" stroke-width="1.5" stroke-linejoin="round"/>
              <circle cx="23.5034" cy="21.2319" r="0.75" fill="#1E3B89"/>
            </svg>
            Питання
          </button>
          <button
              type="button"
              class="tabs-btn"
              :class="{active: activeTab === 2}"
              @click="setActiveTab(2)"
          >
            <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M26.296 19.7141L25.7873 20.2652L26.296 19.7141L30.8304 23.8997C30.9906 24.0475 31.25 23.934 31.25 23.716V1C31.25 0.861929 31.1381 0.75 31 0.75H1C0.861929 0.75 0.75 0.861929 0.75 1V19C0.75 19.1381 0.861929 19.25 1 19.25H25.109C25.549 19.25 25.9727 19.4157 26.296 19.7141Z"
                  stroke="#1E3B89" stroke-width="1.5"/>
              <path
                  d="M34.296 25.7141L33.7873 26.2652L34.296 25.7141L38.8304 29.8997C38.9906 30.0475 39.25 29.934 39.25 29.716V7C39.25 6.86193 39.1381 6.75 39 6.75H9C8.86193 6.75 8.75 6.86193 8.75 7V25C8.75 25.1381 8.86193 25.25 9 25.25H33.109C33.549 25.25 33.9727 25.4157 34.296 25.7141Z"
                  fill="white" stroke="#1E3B89" stroke-width="1.5"/>
              <path d="M15 11.5H33" stroke="#1E3B89" stroke-width="1.5"/>
              <path d="M15 14.5H33" stroke="#1E3B89" stroke-width="1.5"/>
              <path d="M15 17.5H33" stroke="#1E3B89" stroke-width="1.5"/>
              <path d="M15 20.5H33" stroke="#1E3B89" stroke-width="1.5"/>
            </svg>
            Відповіді
          </button>
        </div>
      </div>

      <div class="questions-wrapper" v-if="activeTab === 1">
        <div
            class="item-block"
            v-for="(key, value) in questions"
            :key="key.id"
        >
          <div class="tag" v-html="key.tag"></div>
          <div class="content">
            <img :src="require(`@/assets/img/cathedra/${key.id}.png`)" alt="">
            <p class="name" v-html="key.name"></p>
            <p class="position" v-html="key.position"></p>
            <p class="work" v-html="key.workPlace"></p>
          </div>
          <button
              class="questions-btn"
              type="button"
              @click="askQuestion(key.id)"
          >
            <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M17.7974 15.1215V1C17.7974 0.723858 17.5735 0.5 17.2974 0.5H1.60505C1.32891 0.5 1.10505 0.723858 1.10505 1V13.3077C1.10505 13.5838 1.32891 13.8077 1.60505 13.8077H13.9922C14.2906 13.8077 14.5822 13.8967 14.8297 14.0633L17.0182 15.5363C17.3503 15.7598 17.7974 15.5219 17.7974 15.1215Z"
                  fill="white" stroke="#00ACE6"/>
              <path
                  d="M7.29736 4.69268C7.51314 4.26113 8.13872 3.46191 9.45121 3.46191C10.3743 3.46191 11.489 4.15208 11.2732 5.66249C11.0574 7.17289 9.11546 7.17289 9.11546 7.60444C9.11546 7.94967 9.11546 8.75522 9.11546 9.11484"
                  stroke="#00ACE6" stroke-linejoin="round"/>
              <circle cx="9.14287" cy="10.6277" r="0.5" fill="#00ACE6" stroke="#00ACE6" stroke-width="0.4"/>
            </svg>
            поставити запитання
          </button>
        </div>
      </div>

      <div class="answers-wrapper" v-if="activeTab === 2">
        <div class="info">
          Думка вчених може не співпадати з позицією компанії Nutricia
          <div class="icon">
            <svg width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M2.95685 14.7198H0.694818V4.31041H2.95685V14.7198ZM0.560059 1.55277C0.560059 1.15747 0.669149 0.853158 0.887331 0.639824C1.11193 0.426491 1.42958 0.319824 1.84027 0.319824C2.23813 0.319824 2.54615 0.426491 2.76434 0.639824C2.98894 0.853158 3.10123 1.15747 3.10123 1.55277C3.10123 1.92924 2.98894 2.22728 2.76434 2.44688C2.54615 2.66022 2.23813 2.76688 1.84027 2.76688C1.42958 2.76688 1.11193 2.66022 0.887331 2.44688C0.669149 2.22728 0.560059 1.92924 0.560059 1.55277Z"
                  fill="#1E3B89"/>
            </svg>
          </div>
        </div>
        <div
            class="item-block"
            v-for="(key, value) in answers"
            :key="key.id"
            :id="key.id"
        >
          <div class="tag" v-html="key.tag"></div>
          <div class="content">
            <p class="date" v-html="key.date"></p>
            <div class="asker">
              <p class="name" v-html="key.asker.name"></p>
              <p class="position" v-html="key.asker.position"></p>
              <p class="text">
                {{ key.asker.text }}
              </p>
            </div>
            <div class="respondent">
              <div class="respondent-info">
                <img :src="require(`@/assets/img/cathedra/${key.respondent.id}.png`)" alt="">
                <div class="details">
                  <p class="name" v-html="key.respondent.name"></p>
                  <p class="position" v-html="key.respondent.position"></p>
                </div>
              </div>
              <p
                  class="text"
                  v-html="activeMore === key.id ? key.respondent.text : key.respondent.text.substring(0, 98) + '...'"
              >
              </p>
              <p
                  class="links"
                  v-html="key.respondent.links"
                  v-if="activeMore === key.id && key.respondent.links.length"
              ></p>
            </div>
            <button
                type="button"
                class="more-btn"
                :class="{active: activeMore === key.id}"
                @click="showMore(key.id)"
            >
              {{ activeMore !== key.id ? 'Показати повністю' : 'Згорнути' }}
              <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.44645 4.06836L4.44531 1.28317" stroke="#00ACE6" stroke-width="1.5" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.44562 1.28317L1.44678 4.06836" stroke="#00ACE6" stroke-width="1.5" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "cathedra",
  data: () => ({

    activeTab: 1,
    activeMore: null,

    questions: [
      {
        id: 1,
        tag: 'Педіатрія',
        name: 'Сергій Леонідович Няньковський',
        whom: 'С.Л. Няньковському',
        position: 'д.м.н., професор, експерт ESPGHAN',
        workPlace: 'Львівський національний медичний університет імені Данила Галицького',
      },
      {
        id: 2,
        tag: 'Дитяча гастроентерологія',
        name: 'Олег Геннадійович Шадрін',
        whom: 'О.Г. Шадріну',
        position: 'д.м.н., професор, експерт ESPGHAN',
        workPlace: "ІПАГ імені академіка О.М. Лук'янової НАМН України",
      },
      {
        id: 3,
        tag: 'Дитяча алергологія',
        name: 'Тетяна Рудольфівна Уманець',
        whom: 'Т.Р. Уманець',
        position: 'д.м.н., професор, експерт МОЗ України',
        workPlace: "ІПАГ імені академіка О.М. Лук'янової НАМН України",
      },
      {
        id: 4,
        tag: 'Неонатологія',
        name: 'Дмитро Олександрович Добрянський',
        whom: 'Д.О. Добрянському',
        position: 'д.м.н., професор, експерт МОЗ України',
        workPlace: 'Львівський національний медичний університет імені Данила Галицького',
      },
      {
        id: 5,
        tag: 'Клінічна нутриціологія, паліатив',
        name: 'Тетяна Валеріївна Куріліна ',
        whom: 'Т.В. Куріліній',
        position: 'д.м.н., професор',
        workPlace: "Національний університет охорони здоров'я України імені П.Л. Шупика",
      },
      {
        id: 6,
        tag: 'Клінічна нутриціологія, онкологія',
        name: 'Анастасія Олександрівна Горобець',
        whom: 'А.О. Горобець',
        position: 'к.м.н., доцент',
        workPlace: 'Національний медичний університет імені О.О. Богомольця',
      },
    ],
    answers: [
      {
        id: 1,
        tag: 'Клінічна нутриціологія',
        date: '09.06.2021',
        asker: {
          name: 'Матвіюк С.В.',
          position: 'генетик (Одеса)',
          text: "Яке лікувальне харчування можна призначити дитині до 1 року зі спінальною м'язовою атрофією?",
        },
        respondent: {
          id: 5,
          name: 'Куріліна Т.В.',
          position: 'д.м.н., професор',
          text: `При першому типі СМА, що визначається дуже раннім віком початку зі швидко прогресуючим перебігом (синдром Werdnig-Hoffmann), спостерігаються виразні проблеми з ковтанням і затримка росту. Особливості, що впливають на нутритивний стан: поганий контроль голови, слабкість м’язів, які відповідають за ковтання, дисфагічні порушення з високим ризиком хронічного аспіраційного обструктивного бронхіту та/або пневмонії, зригування/блювота, гастроезофагеальна рефлюксна хвороба. Розлади призводять до «синдрому недостатності харчування» із затримкою фізичного розвитку. Чинниками є підвищені потреби (посилення зусиль для забезпечення дихання й рухової активності) водночас з аліментарною нестачею харчових субстратів. Вимоги до харчування пацієнтів зі СМА:
                    <ul>
                      <li>збалансоване за основними компонентами (вміст білка – 10-15% енергетичних потреб);</li>
                      <li>не рекомендовано жодної спеціальної дієти, не доведено переваг харчування продуктами з глибоким гідролізом білка або елементними (амінокислотними) формулами;</li>
                      <li>індивідуальний підхід;</li>
                      <li>вітаміни й мінерали у якості нутритивних суплементів (вітамін D, препарати кальцію тощо);</li>
                      <li>зменшення кількості жирів тваринного походження мінімізує прояви ГЕРХ;</li>
                      <li>менші й частіші прийоми їжі (голодування за рахунок великих проміжків часу між прийомами їжі може призвести до гіпоглікемії і катаболічного стану з додатковою атрофією м’язів, тому рекомендовані прийоми їжі кожні 4 години вдень, а вночі залежно від нутритивного статусу).</li>
                    </ul>
                    Організація нутритивної підтримки для дітей зі СМА завжди розпочинається з антропометричної оцінки, розрахунку енергетичних потреб (базовий обмін з конверсійними коефіцієнтами), вибору продуктів клінічного харчування й визначення шляхів введення їжі (суплементація сіпінгом, ентеральне харчування – через зонд або гастростому).
                    Для дітей до року може бути призначена ізокалорійна суміш <a href="/production-energy/14">Infatrini</a> (1 ккал/мл) у якості додаткового компоненту на фоні основної молочної суміші або грудного молока (розраховуємо об’єм до 30% від енергетичних потреб під контролем антропометрії з можливим підвищенням кількості у разі незадовільного збільшення маси тіла).
                    Формули на основі глибокого гідролізу застосовуємо лише у разі доведеної інтестинальної недостатності (синдром короткого кишечника, прооперований кишечник) та непереносимості білків коров’ячого молока. Для дітей до року з інтестинальною недостатністю можна застосовувати ізокалорійну суміш <a href="/production-energy/15"><nobr>Infatrini Peptisorb</nobr></a> (1 ккал/мл) з глибоким гідролізом білку.
                    `,
          links: ''
        }
      },
      {
        id: 2,
        tag: 'Педіатрія',
        date: '16.06.2021',
        asker: {
          name: 'Панчишин Н.О.',
          position: 'сімейний лікар (Щирець, Львівська область)',
          text: 'Яким чином виготовляється амінокислотна суміш? – в результаті глибокого гідролізу білка?',
        },
        respondent: {
          id: 1,
          name: 'Няньковський С.Л.',
          position: 'д.м.н., професор',
          text: `Амінокислотна суміш отримується шляхом розщеплення (гідролізу) білка на вільні амінокислоти (найдрібніші молекули білкового ланцюга).
                    Термінологічний нюанс: «глибоким» («повним», «значним») гідролізом називають розщеплення білка не на амінокислоти, а на крупніші молекули – коротколанцюгові пептиди (шматочки білкового ланцюга, поміж яких інколи можуть міститись вільні амінокислоти, але невеликий %). Глибокогідролізовані суміші застосовуються для дієтотерапії харчової алергії до білків коров’ячого молока легкого й середнього ступеню тяжкості.
                    Амінокислотні суміші містять виключно вільні амінокислоти (не містять навіть коротколанцюгових пептидів), тож не викликають алергічних реакцій і можуть застосовуватись за різних станів, включно при харчовій алергії до білків коров’ячого молока тяжкого ступеню.
                    `,
          links: 'Прикладами глибокогідролізованих сумішей є <a href="/production/1"><nobr>Nutrilon Пепті</nobr></a>, <a href="/production/4"><nobr>Nutrilon Мальабсорбція</nobr></a> й <a href="/production-energy/15"><nobr>Infatrini Петісорб</nobr></a>, прикладом амінокислотної суміші є <a href="/production/16">Neocate</a>.'
        }
      },
      {
        id: 3,
        tag: 'Дитяча алергологія',
        date: '18.06.2021',
        asker: {
          name: 'Клименчук Н.М.',
          position: 'реаніматолог (Нікополь, Дніпропетровська область)',
          text: 'До якого віку рекомендується використовувати суміш Nutrilon Пепті?',
        },
        respondent: {
          id: 3,
          name: 'Уманець Т.Р.',
          position: 'д.м.н., професор',
          text: `Дітям з харчовою алергією до білків коров'ячого молока за неможливості грудного вигодовування суміш <a href="/production/1"><nobr>Nutrilon Пепті</nobr></a> рекомендована до року. У випадку гастроінтестинальної форми харчової алергії – до 18 місяців.`,
          links: ''
        }
      },
      {
        id: 4,
        tag: 'Педіатрія',
        date: '18.06.2021',
        asker: {
          name: 'Гарич Н.І.',
          position: 'педіатр (Дніпро)',
          text: 'Як впливає пальмова олія у сумішах Nutrilon на судини дитини?',
        },
        respondent: {
          id: 1,
          name: 'Няньковський С.Л.',
          position: 'д.м.н., професор',
          text: `Щоб відповісти на це питання, давайте розберемо, які жири входять до складу грудного молока й сумішей Nutrilon. У складі грудного молока приблизно 25% від вмісту усіх жирних кислот становить частка пальмітинової кислоти, що є важливим джерелом енергії. До складу дитячих молочних сумішей додають жири, комбінуючи їх так, щоб сукупна частка пальмітинової кислоти дорівнювала її кількості у грудному молоці. Для цього використовують різні рослинні олії, а саме високоолеїнову соняшникову, кокосову, соєву, рапсову й пальмову (олеїнову фракцію).
                    Високоочищений пальмовий олеїн – рідка фракція пальмової олії, що багата на пальмітинову кислоту. На сьогоднішній день це найпоширеніша основа жирового складу дитячих сумішей, частка якої у жировій компоненті сягає 45% і більше. Завдяки пальмовому олеїну жировий склад сумішей вдається наблизити до складу грудного молока. Звичайно, це не має негативного впливу на судини.
                    `,
          links: ''
        }
      },
      {
        id: 5,
        tag: 'Дитяча гастроентерологія',
        date: '18.06.2021',
        asker: {
          name: 'Войтушенко Г.М.',
          position: 'дерматолог (Київ)',
          text: 'Як довго слід використовувати безлактозну суміш?',
        },
        respondent: {
          id: 2,
          name: 'Шадрін О.Г.',
          position: 'д.м.н., професор',
          text: `За потреби (наприклад, при деяких спадкових захворюваннях) безлактозну суміш можна застосовувати стільки, скільки потрібно. Якщо мова йде про дітей з транзиторною чи вторинною лактазною недостатністю, суміш призначається зазвичай на 1-2 місяці з наступним переходом на низьколактозні або базові суміші.`,
          links: 'Прикладом безлактозної суміші є <a href="/production/2"><nobr>Nutrilon Безлактозний</nobr></a>, прикладами низьколактозних сумішей є <a href="/production/0"><nobr>Nutrilon Комфорт 1</nobr></a> і <a href="/production/3"><nobr>Nutrilon Комфорт 2</nobr></a>, <a href="/production/5"><nobr>Nutrilon Кисломолочний 1</nobr></a> і <a href="/production/8"><nobr>Nutrilon Кисломолочний 2</nobr></a>, прикладами базових сумішей є <a href="/production/9"><nobr>Nutrilon 1</nobr></a> і <a href="/production/10"><nobr>Nutrilon 2</nobr></a>.'
        }
      },
      {
        id: 6,
        tag: 'Дитяча гастроентерологія',
        date: '18.06.2021',
        asker: {
          name: 'Потапюк Т.В.',
          position: 'педіатр (Київ)',
          text: 'Чи можна використовувати жирову емульсію Liquigen у поліклінічній практиці? Якщо так, то при яких станах?',
        },
        respondent: {
          id: 2,
          name: 'Шадрін О.Г.',
          position: 'д.м.н., професор',
          text: `Питання просте і непросте. Жирова емульсія <a href="/clinical/product/oral/10">Liquigen</a>, з власного досвіду, призначається дітям зі складними і доволі рідкісними захворюваннями – при захворюваннях печінки, підшлункової залози, після операції, а також у якості доповнення до базисного харчування. Зазвичай розрахунок дози відбувається в стаціонарі й корегується при виписці залежно від необхідної кількості жирів для дитини певного віку, маси тіла й харчування. Таким чином використання жирової емульсії переходить на поліклінічний етап допомоги. Призначення амбулаторно в більшості випадків контролюється лікарем-генетиком або гастроентерологом (з відповідними розрахунками й рекомендаціями щодо кількості жирового компоненту в раціоні).`,
          links: ''
        }
      },
      {
        id: 7,
        tag: 'Клінічна нутриціологія',
        date: '25.06.2021',
        asker: {
          name: 'Томашевська К.А.',
          position: 'педіатр (Ірпінь, Київська область)',
          text: "Дитина з гіпоплазією нирок (ХНН II ступеня) народилась на 33 тижні, зараз 7 місяців, вага 5500 г, вигодовується сумішшю Friso VOM 2 (7 разів на добу по 126 мл), креатинін і сечовина в нормі, але зригує 1 раз на добу (1 раз на тиждень всім об'ємом їжі). Чи варто переходити на частково гідролізовану суміш? Що порадите з прикорму?",
        },
        respondent: {
          id: 6,
          name: 'Горобець А.О.',
          position: 'к.м.н., доцент',
          text: `Потреба у білку у даному випадку становить 1,4-1,5 г/кг/добу. Орієнтуйтесь на показники сечовини – при підвищенні її концентрації зменшуйте добову кількість білку до нижньої норми (1,2 г/кг/добу) задля виключення можливої дегідратації. Найкращі суміші для таких діток – на основі сироваткового білку (не можна застосовувати формули на основі казеїну й сої). Суміш Friso VOM підходить, у т.ч. завдяки вмісту загущувача, що у даному випадку актуально, враховуючи зригування. Якщо динаміка набору ваги позитивна, змінювати суміш на гідролізат немає сенсу. Якщо вага «стоїть» і ви «звинувачуєте» у цьому зригування (що малоймовірно з огляду на їх частоту), та/або є синдром мальдигестії/мальабсорбції (порушення процесів травлення й всмоктування у кишечнику), то можна спробувати суміш на основі гідролізату. Прикорм вводиться у повній відповідності до правил введення прикорму до раціону здорових діток. Якщо каша готується на суміші, слід враховувати молочний білок у розрахунку добового споживання білку. Це стосується білка й у інших продуктах прикорму (наприклад, крупах). Якщо має місце підвищення рівнів фосфору й калію у сироватці крові, до раціону не вводяться багаті на ці елементи продукти.`,
          links: 'Прикладом суміші на основі часткового гідролізату сироваткового білка із амілопектином у якості загущувача для дітей після 6 місяців є <a href="/production/3"><nobr>Nutrilon Комфорт 2</nobr></a>.'
        }
      },
      {
        id: 8,
        tag: 'Клінічна нутриціологія',
        date: '25.06.2021',
        asker: {
          name: 'Юрків І.В.',
          position: 'педіатр (Коростишів, Житомирська область)',
          text: "Чи потрібно давати креон дитині з муковісцидозом на прийом суміші Nutridrink Powder, яку вона отримує між основними прийомами їжі?",
        },
        respondent: {
          id: 5,
          name: 'Куріліна Т.В.',
          position: 'д.м.н., професор',
          text: `Так, призначення клінічного харчування для хворих на муковісцидоз дітей потребує розрахунку кількості додаткових ферментів. Дозування залежить від ступеня панкреатичної недостатності, виразності стеатореї, клінічних симптомів, а також складу жирів у формулі. Зазвичай призначають від 500 до 4000 (максимально) одиниць ліпази на 1 г жиру у продукті (або орієнтовно 2000-15000 одиниць креону на 100 мл суміші). Розрахунок креону можна не вести лише на кількість середньоланцюгових тригліцеридів. Єдиний в Україні продукт, який не потребує підтримки ферментами, – жирова емульсія <a href="/clinical/product/oral/10">Liquigen</a> (49% середньоланцюгових тригліцеридів, 51% води). Суміш <a href="/clinical/product/oral/7">Nutridrink Powder</a> не містить середньоланцюгових тригліцеридів, отже на увесь об’єм жиру у ній (3,3 г / 100 мл) слід розрахувати відповідну кількість креону. Також слід зауважити, що згадана суміш призначена не для дітей, а для дорослих віком від 18 років. Дітям може бути призначена суміш <a href="/production-energy/13"><nobr>Nutrison Powder</nobr></a>, яка також не містить середньоланцюгових тригліцеридів і потребує розрахунку креону на увесь об’єм жиру у ній (3,9 г / 100 мл).`,
          links: ''
        }
      },
      {
        id: 9,
        tag: 'Клінічна нутриціологія',
        date: '25.06.2021',
        asker: {
          name: 'Лисюк А.І.',
          position: 'сімейний лікар (Квасилів, Рівненська область)',
          text: "Пацієнтка з раком шлунку, білково-енергетичною недостатністю II ступеня, дисфагією, хронічним больовим синдромом. Яку суміш рекомендуєте? Які порадите посиндромні засоби?",
        },
        respondent: {
          id: 6,
          name: 'Горобець А.О.',
          position: 'к.м.н., доцент',
          text: `Для підбору харчування необхідно врахувати вік пацієнтки, тип ентерального харчування – повне або часткове (якщо часткове, який калораж отримує з інших продуктів харчування), індивідуальні харчові непереносимості, супутні хронічні захворювання, наявність проявів саме кишкової диспепсії, а також лікування, яке проходить пацієнтка.<br>Якщо мова йде про дорослого пацієнта, для повного та часткового ентерального харчування рекомендую <a href="/clinical/product/probe/5"><nobr>Nutrison Energy</nobr></a> або <a href="/clinical/product/probe/1"><nobr>Nutrison Protein Intence</nobr></a> (при значному дефіциті білка), можна в комбінації з <a href="/clinical/product/oral/5"><nobr>Nutridrink Compact Protein</nobr></a>. При схильності до запорів – <a href="/clinical/product/probe/4"><nobr>Nutrison MultiFibre</nobr></a>, можна в комбінації з <a href="/production-energy/17"><nobr>Nutridrink Compact Fibre</nobr></a>. При супутніх порушеннях метаболізму вуглеводів найкращим вибором є <a href="/clinical/product/probe/0"><nobr>Nutrison Diason Energy</nobr></a>, можна в комбінації з <a href="/clinical/product/oral/8"><nobr>Cubitan</nobr></a>. Якщо дисфагія виражена і є причиною зригувань та зменшення в результаті цього надходження суміші до шлунково-кишкового тракту, то слід застосовувати загущувач <a href="/clinical/product/oral/9"><nobr>Nutilis Clear</nobr></a>, додаючи його до кожної порції суміші. На жаль, продуктів, які були б здатні специфічно впливати на хронічний біль, немає. Харчування повинно бути максимально щадним механічно (блендерити або іншим чином подрібнювати їжу), термічно (намагатися уникати сирих продуктів, особливо сирих овочів, фруктів і ягід, які подразнюють слизову оболонку шлунка і стимулюють продукцію шлункового соку). Вживати їжу слід дрібно й часто, можна спробувати в охолодженому до кімнатної температури або трішки нижче стані – в багатьох випадках це допомагає зменшити прояви дисфагії. Крім того, їжу слід приймати у гарно провітреній кімнаті без сторонніх харчових запахів, які можуть бути неприємними пацієнту. Можна запивати їжу маленькими ковтками улюблених напоїв або сумішшю через соломинку.`,
          links: ''
        }
      },
      {
        id: 10,
        tag: 'Педіатрія',
        date: '25.06.2021',
        asker: {
          name: 'Лисюк А.І.',
          position: 'сімейний лікар (Квасилів, Рівненська область)',
          text: "Дитина 2 років, після опіків, алопластика, потребує набору маси, загоєння ран. Яку суміш рекомендуєте?",
        },
        respondent: {
          id: 1,
          name: 'Няньковський С.Л.',
          position: 'д.м.н., професор',
          text: `На першому етапі необхідно розрахувати добову потребу дитини у білках і калоріях. Потреба буде однозначно вища, ніж у здорової дитини, оскільки при опіках втрачається білок. Для розрахунку можна використати калькулятор суміші <a href="/production-energy/12"><nobr>Nutrini</nobr></a> або <a href="/production-energy/13"><nobr>Nutrison Powder</nobr></a> (обидві показані дітям цього віку). На другому етапі оцініть, скільки реально білка і калорій споживає дитина в день. Відніміть від добової потреби ту кількість білка й калорій, яку дитина споживає з основного раціону, й отримаєте різницю – дефіцит. Якою з сумішей краще коригувати цей дефіцит – залежить від об’єму, що необхідно додати на добу. Якщо він великий, можна призначити рідку суміш <a href="/production-energy/12"><nobr>Nutrini</nobr></a> (500 мл у пляшці, треба використати протягом доби після відкриття), якщо об’єм буде невеликим, фінансово вигіднішою є суміш <a href="/production-energy/13"><nobr>Nutrison Powder</nobr></a> (430 г у банці, зберігається протягом місяця після відкриття). Коли ви скоригуєте потребу у білках, подивіться, чи залишився дефіцит калорій. Якщо так – додайте жирову емульсію <a href="/clinical/product/oral/10">Liquigen</a> (містить середньоланцюгові тригліцериди, що легко засвоюються).`,
          links: ''
        }
      },
      {
        id: 11,
        tag: 'Педіатрія',
        date: '25.06.2021',
        asker: {
          name: 'Лисюк А.І.',
          position: 'сімейний лікар (Квасилів, Рівненська область)',
          text: "Дитина 9 місяців, температура 38,0 °C, неспокій, плач, синдром прорізування зубів, виразкова форма кандидозного стоматиту, протягом 3 днів відмовляється від їжі. Що можна порекомендувати з харчування й лікування?",
        },
        respondent: {
          id: 4,
          name: 'Добрянський Д.О.',
          position: 'д.м.н., професор',
          text: `
                Лікування стоматиту – першочергове завдання:
                <ul>
                  <li>декілька крапель 1-2% водного розчину метиленового синього на слизову рота;</li>
                  <li>наносити на слизову рота за допомогою ватної палички 3-4 рази на добу 1% розчин кандид для ротової порожнини;</li>
                  <li>додатково обробляти слизову оболонку рота 1% розчином натрію гідрокарбонату 3-4 рази на добу;</li>
                  <li>за потреби – додатково обліпихова олія;</li>
                  <li>консультація стоматолога.</li>
                </ul>
                Диференціювати причину гіпертермії (зокрема, такою причиною можуть бути не прорізування зубів, а стоматит):
                <ul>
                  <li>переконатись у відсутності інших об’єктивних відхилень від норми;</li>
                  <li>лікувати стоматит;</li>
                  <li>призначити парацетамол: 120 мг ефералгану (3% сироп) 3-4 рази на добу (поки тримається температура не нижча за 38 °C).</li>
                </ul>
                Харчування:
                <ul>
                  <li>рідкі або напіврідки страви до загоєння стоматиту;</li>
                  <li>грудне молоко (оптимально, якщо є) або базова молочна суміш для немовлят – 3-4 рази на добу 200 мл;</li>
                  <li>напіврідкі каші, некислі овочеві пюре;</li>
                  <li>поступове розширення дієти з покращенням стану дитини.</li>
                </ul>
                `,
          links: 'Прикладом базової молочної суміші для дітей від 6 до 12 місяців є <a href="/production/10"><nobr>Nutrilon 2</nobr></a>.'
        }
      },
      {
        id: 12,
        tag: 'Дитяча гастроентерологія',
        date: '25.06.2021',
        asker: {
          name: 'Атрощенко О.В.',
          position: 'неонатолог (Суми)',
          text: "Чи можна при підозрі на лактазну недостатність призначити не безлактозну суміш, а препарат лактази, враховуючи, що лактоза організму потрібна, а відповідний препарат є?",
        },
        respondent: {
          id: 2,
          name: 'Шадрін О.Г.',
          position: 'д.м.н., професор',
          text: `Якщо дитина знаходиться на штучному вигодовуванні і є підозра на лактазну недостатність, можна перейти на низьколактозну або безлактозну суміш (з наступним переходом на низьколактозну). Якщо суміш змінювати немає можливості, можна додати в суміш лактазу.`,
          links: 'Прикладами низьколактозних сумішей є <a href="/production/0"><nobr>Nutrilon Комфорт 1</nobr></a> і <a href="/production/3"><nobr>Nutrilon Комфорт 2</nobr></a>, <a href="/production/5"><nobr>Nutrilon Кисломолочний 1</nobr></a> і <a href="/production/8"><nobr>Nutrilon Кисломолочний 2</nobr></a>. Прикладом безлактозної суміші є <a href="/production/2"><nobr>Nutrilon Безлактозний</nobr></a>.'
        }
      },
      {
        id: 13,
        tag: 'Педіатрія',
        date: '12.10.2021',
        asker: {
          name: 'Ганношина Н.О.',
          position: 'педіатр (Рівне)',
          text: "Дитина 10 місяців з недоношеністю II ступеня при народженні з гастроінтестинальною формою алергії на БКМ (здуття, кольки, розріджений стул з домішками крові) на змішаному вигодовуванні (елімінаційна дієта матері з виключенням БКМ й догодовування сумішшю Nutrilon Пепті). З якого віку й яким чином до раціону дитини вводити молочні продукти?",
        },
        respondent: {
          id: 1,
          name: 'Няньковський С.Л.',
          position: 'д.м.н., професор',
          text: `
                Є два варіанти, що залежать від того, чи продовжуються в дитини описані симптоми:
                <ul>
                  <li>якщо симптоми продовжуються й виключені інші причини (наприклад, кишкова інфекція), дитині може бути недостатньо глибокого гідролізу білка у суміші <a href="/production/1"><nobr>Nutrilon Пепті</nobr></a>, а дієта матері може містити БКМ. Важливо перевірити, чи виключені з елімінаційної дієти матері усі продукти, <a href="/library-item/compendium/27" style="border: none; text-decoration: underline;">що містять БКМ</a>, <a href="/library-item/compendium/28" style="border: none; text-decoration: underline;">можуть містити БКМ</a> і <a href="/library-item/compendium/29" style="border: none; text-decoration: underline;">можуть викликати перехресну реакцію</a>. Дитину слід перевести на амінокислотну суміш, прикладом якої є <a href="/production/16">Neocate</a>. На такій дієті дитина повинна знаходитися мінімум 6-9 місяців безперервно, після чого може бути розглянуте питання введення молочних продуктів;</li>
                  <li>якщо зараз жодних симптомів немає, дитина й мати повинні знаходитись на поточній елімінаційній дієті без БКМ мінімум 6-9 місяців безперервно. Молочні продукти можуть бути введені після завершення елімінаційної дієти, але не раніше досягнення дитиною 12 місяців.</li>
                </ul>
                Матері, оскільки вона на безмолочній дієті, не забудьте призначити кальцій 1000-1200 мг і вітамін D 400 МО на добу.<br>
                Молочні продукти прикорму до 12 місяців не вводимо у будь-якому випадку (якщо IgE був підвищений – не вводимо до 18 місяців). Вони можуть бути введені до раціону лише по закінченню безперервної елімінаційної дієти мінімальної тривалості 6-9 місяців.
              `,
          links: '',
        }
      },
    ]
  }),

  mounted() {

    this.popupActive = this.popupInfo;

    if (sessionStorage.getItem("production") !== null) {
      sessionStorage.removeItem("production")
    }
  },
  methods: {
    declOfNum(number, titles) {
      let cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },

    openDropListNeed() {
      if (this.dropList === false) {
        this.dropList = true
      } else {
        this.dropList = false
      }
    },

    setActiveTab(tab) {
      this.activeTab = tab;
    },

    showMore(id) {
      if (this.activeMore !== id) {
        this.activeMore = id;
      } else {
        this.activeMore = null;
      }

      setTimeout(() => {
        document.getElementById(id).scrollIntoView({block: "start", behavior: "smooth"})
      }, 0);
    },

    askQuestion(id) {
      localStorage.setItem("specialist", JSON.stringify(this.questions.find(item => item.id === id)));
      this.$router.push('/pediatrics/cathedra/question')
    },

    closePopup() {
      this.popupActive = null;
    },

    async getUserData() {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem("key");
      return axios.get(this.$root.globalUrl + "api/v1/security/participant", {})
          .then((res) => JSON.parse(res.data))
    },
  }
}
</script>

<style lang="scss">
@import "../style/vars";

.cathedra {

  * {
    -webkit-tap-highlight-color: transparent;
  }

  .head-links {
    background-color: rgba(255, 255, 255, 0.49);
    width: 100%;
    padding: 10px 15px;

    .back-links {
      color: #7392B1;
      font-family: $fontR;
      font-size: 11px;
    }

    span {
      padding: 0 5px;
      color: #7392B1;
      font-family: $fontR;
      font-size: 11px;
    }

    .now-page {
      color: #00ACE6;
      font-family: $fontSB;
      font-size: 11px;
    }
  }
}

.content-wrapper {
  position: relative;

  .top-block {
    background-color: white;
    margin: 11px 15px 27px;

    .h2-title {
      text-align: center;
      padding: 11px 0;
      color: #9AB9D8;
      font-family: $fontB;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 2px;
      border-bottom: 1px solid #DAE3ED;
    }

    .tabs {
      display: flex;
      padding: 13px 0;

      &-btn {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding: 24px 0 14px;
        background-color: transparent;
        font-size: 15px;
        line-height: 20px;
        text-align: center;
        color: #1E3B89;
        border: none;
        outline: none;
        cursor: pointer;

        &.active,
        &:active {
          background-color: transparent;

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -13px;
            width: 100%;
            height: 2px;
            background-color: #00ACE6;
          }
        }

        svg {
          margin-bottom: 9px;
        }

        &:first-of-type {
          border-right: 1px solid #DAE3ED;
        }

        &:disabled {
          color: #DAE3ED;
          cursor: not-allowed;
        }
      }
    }
  }
}

.tag {
  position: absolute;
  top: 0;
  right: 0;
  padding: 12px 10px 15px;
  font-size: 12px;
  line-height: 122.56%;
  color: #00ACE6;
  background: #D9F3FB;
  border-radius: 0px 4px 0px 12px;
}

.questions-wrapper {
  padding: 0 15px;

  .item-block {
    position: relative;
    padding: 24px 24px 48px;
    margin-bottom: 24px;
    background: #FFFFFF;
    border-radius: 4px;

    .content {
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
      height: 100%;
      color: #1E3B89;

      img {
        width: 52px;
        margin-bottom: 9px;
      }

      .name {
        margin-bottom: 3px;
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
      }

      .position {
        margin-bottom: 9px;
        font-weight: 300;
        font-size: 12px;
        line-height: 16px;
      }

      .work {
        font-weight: 300;
        font-size: 10px;
        line-height: 14px;
      }
    }

    .questions-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 15px 0;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
      background-color: transparent;
      border: none;
      border-top: 1px solid #DAE3ED;
      outline: none;
      color: #00ACE6;
      cursor: pointer;

      svg {
        margin-right: 8px;
      }
    }
  }
}

.answers-wrapper {
  padding: 0 15px;

  .info {
    position: relative;
    width: auto;
    padding: 9px 6px 12px 19px;
    margin-left: 25px;
    margin-bottom: 20px;
    font-size: 13px;
    line-height: 130%;
    color: #1E3B89;
    border: 1px solid #1E3B89;
    border-radius: 4px;

    .icon {
      position: absolute;
      z-index: 1;
      left: -12px;
      top: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #1E3B89;
      background-color: #eff3f8;
    }
  }

  .item-block {
    position: relative;
    padding: 24px;
    margin-bottom: 24px;
    background: #FFFFFF;
    border-radius: 4px;
    overflow-x: hidden;

    .content {
      color: #1E3B89;

      .date {
        margin-bottom: 24px;
        font-weight: 300;
        font-size: 10px;
        line-height: 14px;
      }

      .name {
        margin-bottom: 3px;
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
      }

      .position {
        margin-bottom: 9px;
        font-weight: 300;
        font-size: 12px;
        line-height: 16px;
      }

      .asker {
        border-bottom: 1px solid #DAE3ED;

        .text {
          margin-bottom: 13px;
          font-weight: 600;
          font-size: 15px;
          line-height: 20px;
          transition: .4s;
        }
      }

      .respondent {
        img {
          width: 52px;
          margin-right: 12px;
        }

        &-info {
          display: flex;
          align-items: center;
          padding: 15px 0;

          .position {
            margin-bottom: 0;
          }
        }

        .text {
          font-weight: 300;
          font-size: 15px;
          line-height: 140%;
          margin-bottom: 15px;
          transition: .4s;

          ul, ol {
            padding-left: 20px;
          }
        }

        .links {
          width: 114%;
          background: #e0e9f1;
          margin-left: -7%;
          padding: 15px 24px;
          margin-bottom: 15px;
          font-size: 11px;
          line-height: 170%;
          color: #1e3b89;
          font-family: "OpenSans-Regular";

          @media (max-width: 450px) {
            width: 120%;
            margin-left: -10%;
            padding: 15px 10%;
          }
        }

        a {
          font-size: inherit;
          color: #1e3b89;
          padding: 0 2px;
          border: .606867px solid #1e3b89;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          border-radius: 4px;
        }

      }

      .more-btn {
        display: flex;
        align-items: center;
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 12px;
        line-height: 130%;
        color: #00ACE6;

        svg {
          transform: rotate(180deg);
          transition: .4s;
          margin-left: 5px;
        }

        &.active {
          svg {
            transform: rotate(0);
          }
        }
      }

    }
  }
}
</style>
